module.exports = __webpack_public_path__ + "img/banner_news.32888b9.jpg";